import gql from 'graphql-tag';

export class ResourceFragments {
  static listFragment = gql`
    fragment resourceListFragment on Resource {
      id
      contentId
      directory
      resourceType
      title
      updatedAt
      createdAt
    }
  `;

  static detailsFragment = gql`
    fragment resourceDetailsFragment on Resource {
      id
      contentId
      directory
      resourceType
      resourceStatus
      title
      user {
        id
      }
      createdAt
      updatedAt
      deletedAt
    }
  `;
}
